import { useQuery } from '@tanstack/react-query';
import { fetchGenerationModels, type GenerationServiceType } from './api';

/**
 * 画像 or 動画の生成モデル一覧を取得する。レスポンスは sort_order 順に並んでいる。
 */
export function useGenerationModels(serviceType: GenerationServiceType) {
  return useQuery({
    queryKey: ['generation-models', serviceType],
    queryFn: () => fetchGenerationModels(serviceType),
    staleTime: 5 * 60 * 1000,
  });
}
